import { DataPermissionsSettings } from '../members/OrganizationRecordsConfiguration.js';
/**
 * Get the data permission settings from the platform if userMode is platform, or from the organization otherwise.
 * @param platform
 * @param organization
 * @returns
 */
export function getDataPermissionSettings(platform, organization) {
    if (STAMHOOFD.userMode === 'platform') {
        return platform.config.dataPermission;
    }
    if (organization) {
        return organization.meta.dataPermission;
    }
    return null;
}
/**
 * Get the data permission settings from the platform if userMode is platform, or from the organization otherwise.
 * Returns default settings if no settings are found.
 * @param platform
 * @param organization
 * @returns
 */
export function getDataPermissionSettingsOrDefault(platform, organization) {
    return getDataPermissionSettings(platform, organization) ?? DataPermissionsSettings.create({});
}
//# sourceMappingURL=DataPermissionHelper.js.map